import { Drawer, Divider, List, ListItem, ListItemIcon, IconButton, Box } from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Menu as MenuType } from '../../../core/models';
import { useAppContext, useDrawerContext } from '../../../core/contexts';
import { hasFunctionality, hasRole } from 'core/utils/roles';
import { SGSNavMenu } from 'components';
import { useHistory } from 'react-router';
import LogoSelecteur from '../Logos/LogoSelecteur';

type Props = {
    menus: MenuType[];
    onRedirect: Function;
};

// TODO : replace makeStyles with Sidebar.layout.scss when
// maquette is finished
const drawerWidth = 250;
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
        },
        drawerContainer: {},
        drawer: {
            height: '100%',
            display: 'flex',
            flexDirection: 'row',
            position: 'fixed',
            zIndex: 20,
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'pre-wrap',
            border: 'none',
            background: 'white',
            filter: 'drop-shadow(0 0 10px #00000029)',
            overflowX: 'hidden',
        },
        burger: {
            height: 125,
            paddingRight: 0,
        },
        burgerImage: {
            textAlign: 'right',
        },
        logo: {
            width: '100%',
            objectFit: 'contain',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(7) + 1,
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(9) + 1,
            },
        },
        list: {
            background: 'white',
            paddingLeft: '20px',
            zIndex: 1,
        },
        icon: {
            minWidth: 40,
        },
        text: {
            fontSize: 11,
        },
        textHidden: {
            opacity: 0,
        },
        menuTop: {
            height: '40px',
        },
    }),
);

const Sidebar: React.FC<Props> = ({ menus: inputMenus, onRedirect }) => {
    const classes = useStyles();
    const [menus, setMenus] = useState<MenuType[]>([]);
    const { drawerOpen, setDrawerOpen } = useDrawerContext();
    const { user } = useAppContext();
    const history = useHistory();

    useEffect(() => {
        const newMenus = (inputMenus as MenuType[])
            .filter((o) => !o.role || (o.role && hasRole(user, o.role)))
            .map((o) => ({
                ...o,
                menuItems: o.menuItems?.filter((o) => {
                    return !o.role || (o.role && hasRole(user, o.role) && hasFunctionality(user, o.features));
                }),
            }));
        setMenus(newMenus);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputMenus]);

    const handleDrawerChange = () => {
        setMenus(menus.map((o) => ({ ...o, collapsed: true })));
        setDrawerOpen(!drawerOpen);
    };

    return (
        <Drawer
            variant="permanent"
            className={classes.drawerContainer}
            classes={{
                paper: classnames(classes.drawer, {
                    [classes.drawerOpen]: drawerOpen,
                    [classes.drawerClose]: !drawerOpen,
                }),
            }}
        >
            <List disablePadding className={classes.list}>
                <ListItem className="p-0">
                    <ListItemIcon className={classes.icon}>
                        <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerChange} edge="start">
                            <Menu />
                        </IconButton>
                    </ListItemIcon>
                </ListItem>
                <Box className="mb-2">
                    <span onClick={() => history.push('/')} style={{ cursor: 'pointer' }}>
                        <LogoSelecteur drawerOpen={drawerOpen} numAdherent={user.num_adherent} />
                        {/* {drawerOpen ? (
                            <img style={{ marginLeft: -20 }} src={logo} alt="logo-extranet-rh" height="70" width="auto" />
                        ) : (
                            <img style={{ marginLeft: -20 }} src={retractedLogo} alt="logo-extranet-rh" height="70" width="auto" />
                        )} */}
                    </span>
                </Box>
                <Divider />
                <Box className={classes.menuTop}></Box>
                {menus.map(
                    (o) =>
                        (o.menuItems?.length > 0 || o.name === 'Mon Tableau de bord' || o.name === 'Nous Contacter' || (o.name === 'Statistiques' && hasFunctionality(user, ['SANTE']))) && (
                            <SGSNavMenu
                                key={o.name}
                                menu={o}
                                onClick={onRedirect}
                                collapseHandler={() => {
                                    setMenus(menus.map((p) => (o.collapsed ? (o === p ? { ...p, collapsed: false } : { ...p, collapsed: true }) : { ...p, collapsed: true })));
                                }}
                            />
                        ),
                )}
            </List>
        </Drawer>
    );
};

export default Sidebar;
